// extracted by mini-css-extract-plugin
module.exports = {"basicInfo":"_02712f2b3b--basicInfo--Cklaq"};